module.exports = __webpack_public_path__ + "img/score.640eb51c.svg";